import type {Result, UseCase} from 'framework';
import type {ScheduleError} from '../../domain/errors';
import type {ScheduleOccurrence} from '../../domain/schedule-occurrence';
import type {ScheduleRepository, StartedScheduleWorkout} from '../ports/schedule.repository';

export class StartScheduleOccurrence implements UseCase<
  [ScheduleOccurrence],
  StartedScheduleWorkout
> {
  constructor(private readonly repository: ScheduleRepository) {}

  execute(occurrence: ScheduleOccurrence): Promise<Result<StartedScheduleWorkout, ScheduleError>> {
    return this.repository.startOccurrence(occurrence);
  }
}
